import React, { useEffect, useRef, useState } from "react";
import {
    Button,
    Box,
    styled,
    Typography,
    Grid, useTheme
} from '@mui/material';
import { useDropzone } from "react-dropzone";
import { useFormContext } from "react-hook-form";

import { convertPdfToB64 } from "../utils";
import { useTranslation } from 'react-i18next';

const DropZoneContainer = styled(Box)(({ theme }) => ({
    minHeight: 300,
    border: `dashed 2px ${theme.palette.primary.main}`,
    borderRadius: 10,
    padding: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "&:hover": {
        opacity: 0.9,
        cursor: "pointer",
    },
    [theme.breakpoints.down("sm")]: {
        minHeight: 200,
    },
}));

export const UploadDcuments = (props) => {
    const [file, setfile] = useState(null);
    // const [fileUrl, setfileUrl] = useState(null);
    const [fileBase64, setfileBase64] = useState(null);
    const [parsingWordDoc, setparsingWordDoc] = useState(false);
    const [extensionChange, setExtensionChange] = useState(null);
    const [initLoad, setInitLoad] = useState(false);
    const { t } = useTranslation();

    const fileLoader = useRef(null);
    // const titleDocRef = useRef();

    const {
        register,
        formState,
        clearErrors,
        reset,
    } = useFormContext();

    const onDrop = (files) => {
        // console.log("files*******", files)
        if (files.length == 0) {
            console.log("ENTORABORRAR 1", files.length, files)
            alert(`${t("invalid_document_text")} .pdf, .png, .jpg`)
            props.setInitChangeFile(false);
            return null;
        } else {
            const extension = files[0]?.name?.slice((files[0]?.name.lastIndexOf(".") - 1 >>> 0) + 2)
            // const fileName = files[0]?.name?.split(".");
            console.log("Verifica extension", extension)
            console.log("Verifica props?.ExtensionsDoc: ", props?.ExtensionsDoc)
            if (props?.ExtensionsDoc && props?.ExtensionsDoc?.includes(extension)) {
                console.log("ENTORABORRAR 1", files)
                setfile(files[0]);
            } else {
                console.log("ENTORABORRAR 2", props?.ExtensionsDoc, props?.ExtensionsDoc?.includes(extension), extension)
                changeFile();
                props.setInitChangeFile(false);
                alert(`${t("invalid_document_text")} ${props?.ExtensionsDoc ? props?.ExtensionsDoc : ".pdf, .png, .jpg "}`)
                return null;
            }
        }
    };

    const { getRootProps, getInputProps, open, acceptedFiles } = useDropzone({
        onDrop,
        noClick: true,
        accept: props?.ExtensionsDoc ? props?.ExtensionsDoc : {
            'image/png': ['.png'],
            'image/jpg': ['.jpg'],
            'application/pdf': ['.pdf'],
        },
    });

    // const setPdfToB64 = React.useCallback(async () => {
    //     try {
    //         console.log("****setPdfToB64 ***", file)
    //         if (file) {

    //             const { base64result, wordUrl } = await convertPdfToB64(file);
    //             console.log("****setPdfToB64 ************Url,base64result:****",wordUrl, base64result)
    //             setfileBase64(base64result);
    //             setfileUrl(wordUrl);
    //         }
    //     } catch (error) {
    //         setfileBase64(new Error("Error al convertir pdf"));
    //         console.log("Error: setPdfToB64*********: ", error);
    //     }
    // }, [file]);

    useEffect(() => {
        if (!acceptedFiles) {
            console.log("ENTORABORRAR 1.1", acceptedFiles)
            alert(`${t("invalid_document_text")} ${props?.ExtensionsDoc ? props?.ExtensionsDoc : ".pdf, .png, .jpg "}`)
            props.setInitChangeFile(false);
            // Alert({
            //     icon: "error",
            //     text: `Por favor seleccione un tipo de documento válido .docx o .pdf`,
            //     okbtntext: "Aceptar",
            // });
            return null;
        } else {
            setfile(acceptedFiles[0]);
        }
    }, [acceptedFiles]);

    useEffect(() => {
        if (file) {
            async function fetchData() {
                try {
                    console.log("****setPdfToB64 ***", file)
                    const { base64result } = await convertPdfToB64(file);
                    console.log("****setPdfToB64 ************base64result:**11111*", base64result)
                    setfileBase64(base64result);
                } catch (error) {
                    setfileBase64(new Error("Error al convertir pdf"));
                    console.log("Error: setPdfToB64*********: ", error);
                }
            }
            const splitted = file.name.split(".");
            const extention = splitted[splitted.length - 1];
            setExtensionChange(extention)

            fetchData();
        }
    }, [file]);

    useEffect(() => {
        if (fileBase64 != undefined && fileBase64 != null && fileBase64 != "") {
            props.onChange(fileBase64, extensionChange)
        } else {
            if (props.onChange != undefined && props.onChange != null) {
                props.onChange(null, null)
            }
        }
    }, [fileBase64]);

    useEffect(() => {
        // console.log("props.onClear: ", props.onClear)
        if (props.onClear) {
            changeFile()
        }
    }, [props.onClear]);

    let openFileChange = (event) => {
        // console.log("Error: openFileChange************Entro.")
        fileLoader.current.click()
    };

    let getFileLoaded = (event) => {
        // console.log("******getFileLoaded********", event)
        if (event.target.files && event.target.files[0]) {
            onDrop(event.target.files)
        }
    };

    const changeFile = () => {
        setfile(null);
        // setfileUrl(null);
        setfileBase64(null);
        reset();
    };

    useEffect(() => {
        // console.log("props.initLoadChange: , initLoad: ", props.initLoadChange, initLoad)
        if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i)) {
            if (props.initLoadChange && fileLoader.current != undefined && fileLoader.current != null && !initLoad) {
                setInitLoad(true)
                openFileChange()
            }
        }
    }, [props.initLoadChange, fileLoader.current]);

    return (
        <Box sx={{
            width: '100%',
        }}>
            <input
                type="file"
                hidden
                ref={fileLoader}
                accept={props?.ExtensionsDoc ? props?.ExtensionsDoc : "image/jpeg,image/gif,image/png,application/pdf"}
                // accept="application/pdf,.jpg,.png"
                onChange={getFileLoaded}
            />
            {/* <Box ref={titleDocRef}> */}
            <Grid container spacing={2}>
                {/* {file ?
                    <Grid item xs={12} style={{ minHeight: 300 }}>
                        {navigator.userAgent.match(/iPhone/i)
                            // ?
                            // <embed src={fileUrl} type="application/pdf"
                            //     width="100%" height="500vh" />
                            // <iframe id="pdfviewer" src={`https://pdfviewer.net/extended-pdf-viewer/blob=${fileUrl}`} frameborder="0" width="100%" height="100%"></iframe>
                            // :
                            ||
                            navigator.userAgent.match(/Android/i) ?
                            <VisorPDF
                                // parsingDoc={parsingWordDoc}
                                pdfUrl={fileUrl}
                                pdfName={file?.name}
                                height={"50vh"}
                            />
                            : <object width="100%" style={{ height: "61vh" }} data={fileUrl} type='application/pdf' />
                        }
                    </Grid>
                    :  */}
                <Grid item xs={12} >
                    {navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i) ?
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            justifyContent: "center",
                            alignItems: "center",
                            height: '60vh',
                        }}>
                            <Button
                                onClick={openFileChange}
                                color="primary"
                                variant="outlined"
                                sx={{
                                    maxWidth: 380,
                                    fontWeight: "normal",
                                    minHeight: 45,
                                    padding: "5px 10px",
                                    m: "10px auto",
                                }}
                            >
                              {t("document_from")}
                            </Button>
                        </Box>
                        :
                        <DropZoneContainer
                            {...getRootProps()}
                            up
                            sx={{
                                mb: 5,
                                mt: 3,
                                outline: formState.errors.pdf
                                    ? "2px solid tomato"
                                    : "none",
                                outlineOffset: formState.errors.pdf ? -2 : 0,
                            }}
                        >
                            <input
                                {...getInputProps()}
                                accept={props.ExtensionsDoc ? props?.ExtensionsDoc : ".pdf"}
                                // accept={".pdf"}
                                style={{ display: "none" }}
                                {...register("pdf", { required: true })}
                            />
                            <Typography align="center" variant="body2">
                              {t("document_drag")}
                            </Typography>
                            <Typography align="center" variant="body2">
                              {t("general_or")}
                            </Typography>
                            <Button
                                // onClick={openFileChange}
                                onClick={navigator.userAgent.match(/iPhone/i) ||
                                    navigator.userAgent.match(/Android/i) ?
                                    open : openFileChange}
                                color="primary"
                                variant="outlined"
                                sx={{
                                    maxWidth: 380,
                                    fontWeight: "normal",
                                    minHeight: 45,
                                    padding: "5px 10px",
                                    m: "10px auto",
                                }}
                            >
                              {t("document_from")}
                            </Button>
                            {formState.errors.pdf && (
                                <Typography
                                    variant="body1"
                                    align="center"
                                    color="tomato"
                                >
                                    {t("necessary_document_text")}
                                </Typography>
                            )}
                        </DropZoneContainer>
                    }
                </Grid>
                {/* } */}
            </Grid>
            {/* </Box> */}
        </Box>
    );
};